import React from 'react';
import { PlayIcon, SteamIcon } from '../../components/icons';
import { GAME_NAME, STEAM_URL, TAGLINE } from '../../site-config.mjs';
import { trackWishlistClick } from '../../analytics';
import { HERO_FACTS } from './content';
import heroArt from '../../media/hero.jpg';
import heroArtSmall from '../../media/hero-small.jpg';
import wordmark from '../../media/warm-wordmark.png';

export default function Hero() {
  return (
    <section className="hero">
      <div className="hero__art" aria-hidden="true">
        <img
          src={heroArt}
          srcSet={`${heroArtSmall} 1100w, ${heroArt} 2400w`}
          sizes="100vw"
          alt=""
          fetchpriority="high"
        />
      </div>
      <div className="hero__scrim" aria-hidden="true" />

      <div className="shell hero__body">
        <p className="pill pill--ember hero__status">
          <span className="pill__dot" />
          Out now on Steam
        </p>

        {/* The wordmark is the visual title; the text is what crawlers and
            screen readers get, so the image itself is left undescribed. */}
        <h1 className="hero__title">
          <img src={wordmark} alt="" width="582" height="202" />
          <span className="visually-hidden">
            {GAME_NAME}, a co-op winter survival game for PC
          </span>
        </h1>

        <p className="hero__tagline">{TAGLINE}</p>

        <div className="hero__actions">
          <a
            className="btn btn--primary btn--lg"
            href={STEAM_URL}
            target="_blank"
            rel="noreferrer"
            onClick={() => trackWishlistClick('hero')}
          >
            <SteamIcon size={19} />
            Play on Steam
          </a>
          <a className="btn btn--secondary btn--lg" href="#trailer">
            <PlayIcon size={16} />
            Watch the trailer
          </a>
        </div>

        <ul className="hero__facts">
          {HERO_FACTS.map((fact) => (
            <li key={fact}>{fact}</li>
          ))}
        </ul>
      </div>
    </section>
  );
}
